var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6634 26.8495L16.2674 26.6703L12.9314 23.846L10.8742 18.334L15.1425 14.0691L12.8369 11.6884L8.84494 15.1513L6.79297 19.9928L9.29802 27.2292L14.672 31.6856L21.3579 30.6673L20.6634 26.8495Z",
    fill: "#FEE5D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9902 23.3936L17.1618 25.9909L14.3296 20.0176L15.213 15.3837L12.2129 18.5682L13.9902 23.3936Z",
    fill: "#FEE5D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9733 21.8466L36.484 20.7964L35.0198 22.1181L33.4681 22.0684L31.8045 20.4983L33.2477 19.315L32.1421 18.6409L28.6767 19.2831L25.8428 28.1091L27.4592 31.1871L30.9351 31.3379L31.6261 32.9629L34.6297 32.8618L39.0992 26.445L38.9733 21.8466ZM34.0699 30.5981L32.8821 30.1901L36.5959 23.8495L37.2012 24.3942L34.0699 30.5981Z",
    fill: "#FEE5D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5526 21.1847L36.2967 19.6236L37.5842 19.3238L37.7014 18.2275L35.6232 18.334L33.1602 20.6455L33.8424 21.128L34.5526 21.1847Z",
    fill: "#FEE5D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7299 39.0001L2.27588 29.633L0 16.2797H4.04971L6.13492 28.0098L14.3865 35.5779L34.4252 35.3278L41.412 27.2239L43.8278 16.2797H48L45.257 28.6999L36.3914 38.7038L12.7299 39.0001Z",
    fill: "#FEE5D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6624 17.5853L28.3762 16.7018L29.0952 17.0797L30.9757 17.2748L31.8626 15.6143L32.076 14.0088L31.0789 12.719L30.778 10.8012L29.1319 9.76519L27.526 9.65698L26.5446 10.2548L25.2956 10.2921L24.7428 9.74568L24.1638 8.98815L23.6057 8.40449L21.1794 8L19.9461 9.50441L18.3805 10.7409L18.3018 12.2453L19.4476 13.3257L19.8394 13.269L19.9181 15.3624L19.9584 17.4487L19.2132 19.8862L21.5223 22.0435L24.2268 21.5095L25.9778 18.797L27.6677 17.587L27.6624 17.5853ZM21.3823 13.457L22.306 13.3701L22.6838 15.043L21.8634 16.81L21.8756 17.5675L21.5905 16.6699L21.6815 14.8106L21.3823 13.457ZM27.3511 15.6019L26.9295 16.1465L26.2175 16.6255L24.8443 17.7751L24.8005 17.7609L23.478 18.0944L24.3107 15.7012L26.0496 15.6852L26.891 14.5906L27.3511 15.6019Z",
    fill: "#FEE5D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderLight);
export default __webpack_public_path__ + "static/media/icon-order-light.143c8f0f22d857926e535bd82cce8aac.svg";
export { ForwardRef as ReactComponent };